import ActiveCrypt from './crypt.active';

const crypt = new ActiveCrypt();

/**
 *
 * @param string
 * @returns {{}}
 */
export default function queryHelper(
  string
) {
  try{
    let result        = {},
        decryptedData = crypt.decrypt( string );
    decryptedData.fields.map( key => result[key] = decryptedData.input );
    return result;
  } catch( e ){}
}


/** WEBPACK FOOTER **
 ** ./frontend/@/query.helper.js
 **/